import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-file-list-3-line text-background-50 text-base"></i>
                </div>
                <span className="font-heading font-semibold text-foreground-900 text-base whitespace-nowrap">
                  Vigorbuy Spreadsheet
                </span>
              </Link>
              <p className="text-foreground-500 text-xs leading-relaxed mb-4">
                Your trusted resource for organized product discovery, comparisons, and shopping guides. Explore categories, read expert guides, and make smarter purchasing decisions.
              </p>
              <p className="text-foreground-400 text-xs">
                Vigorbuyspread.autos is an independent informational website.
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-foreground-900 text-sm mb-4">Quick Links</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-foreground-500 text-xs hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">Home</Link>
                <Link to="/article/vigorbuy-spreadsheet-guide" className="text-foreground-500 text-xs hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">Shopping Guide</Link>
                <Link to="/article/vigorbuy-spreadsheet-safety" className="text-foreground-500 text-xs hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">Safety Guide</Link>
                <Link to="/article/vigorbuy-spreadsheet-comparison" className="text-foreground-500 text-xs hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">Comparison Guide</Link>
                <Link to="/#categories" className="text-foreground-500 text-xs hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">Product Categories</Link>
                <Link to="/#faq" className="text-foreground-500 text-xs hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">FAQ</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-foreground-900 text-sm mb-4">Popular Categories</h4>
              <div className="flex flex-col gap-2.5">
                {categories.slice(0, 7).map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-500 text-xs hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-foreground-900 text-sm mb-4">More Categories</h4>
              <div className="flex flex-col gap-2.5">
                {categories.slice(7).map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-500 text-xs hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-400 text-xs">
              &copy; {new Date().getFullYear()} Vigorbuyspread.autos. All rights reserved. An independent informational resource.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-primary-500 text-background-50 rounded-md font-medium text-xs hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Visit Main Website
              <i className="ri-arrow-right-up-line text-xs"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}